module.exports = __webpack_public_path__ + "img/custom_client_seed_1_pt.30c90f05.png";